import Swiper from "swiper";
import {
	Pagination,
	Autoplay,
	Navigation,
	EffectFade,
	Thumbs,
	Scrollbar,
	Controller,
} from "swiper/modules";

$(function () {
	const historyYearSlider = new Swiper(".history-year-slider .swiper", {
		modules: [Controller],
		slidesPerView: 3,
		spaceBetween: 16,
		rewind: true,
		centeredSlides: true,
		observeParents: true,
		slideToClickedSlide: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 7,
				spaceBetween: 24,
			},
		},
	});

	const historyContentSlider = new Swiper(".history-content-slider .swiper", {
		modules: [Navigation, Controller],
		slidesPerView: 1,
		spaceBetween: 16,
		observer: true,
		observeParents: true,
		centeredSlides: true,
		rewind: true,
		breakpoints: {
			1024: {
				spaceBetween: 40,
			},
		},
		navigation: {
			nextEl: ".history-content-slider .swiper-btn-next",
			prevEl: ".history-content-slider .swiper-btn-prev",
		},
	});

	historyYearSlider.controller.control = historyContentSlider;
	historyContentSlider.controller.control = historyYearSlider;
});
